import { Link, useLocation } from "react-router-dom";

const NavItem = ({ icon, hlink, title, label, onNavigate }) => {
  const location = useLocation();
  const isActive =
    location.pathname === hlink ||
    (hlink !== "/" && location.pathname.startsWith(hlink));

  return (
    <li className="nav-item">
      <Link
        className={`nav-link ${isActive ? "active" : ""}`}
        to={hlink}
        onClick={onNavigate}
        aria-label={label || title}
        aria-current={isActive ? "page" : undefined}
        title={label || title}
      >
        <span className="nav-link-icon" aria-hidden="true">
          <i className="material-icons">{icon}</i>
        </span>
        {title && <span className="nav-link-text">{title}</span>}
      </Link>
    </li>
  );
};

export default NavItem;
